import { globalStyles } from "consts/spaces";
import styled from "styled-components";
import Blockquote from "assets/icons/blockquote.svg";

export const HomePageContainer = styled.div`
  margin: 0 auto;

  .grey-bg {
    background: var(--Color-Background-Input_hovered, #f7f8f9);

    .slick-slider {
      button:hover {
        background-color: #dcdfe4;
      }
    }
  }

  blockquote {
    font-size: ${globalStyles.fonts.h4};
    background-image: url(${Blockquote});
    padding-top: 33px;
    background-repeat: no-repeat;
    background-position: ${globalStyles.spaces[300]} 0;
    margin: ${globalStyles.spaces[400]} 0;
    padding-left: ${globalStyles.spaces[300]};
    border-left: 4px solid
      ${(props) => props.theme.colorBorderNeutralBolder_hovered};
  }

  .seeMoreButton {
    margin: ${globalStyles.spaces[400]} auto;
    display: flex;
    gap: ${globalStyles.spaces[100]};
    align-items: center;
    color: ${(props) => props.theme.colorPrimaryRed};

    svg {
      transform: rotate(-90deg);
    }
  }

  .home-blogs {
    .col-3 {
      max-width: calc(calc(100% - 72px) / 4);

      @media (max-width: ${globalStyles.breackPoints.md}) {
        max-width: calc(calc(100% - 24px) / 2);
      }

      @media (max-width: ${globalStyles.breackPoints.tablet}) {
        max-width: 100%;
      }
    }
  }

  .home-vlog-title {
    margin-bottom: 32px;

    @media (max-width: 1024px) {
      margin-bottom: 24px;
    }

    @media (max-width: 743px) {
      margin-bottom: 20px;
    }
  }

  h2 {
    margin-bottom: 24px;

    &.lg-space {
      margin-bottom: 48px;
    }
  }

  .home-projects {
    padding: 80px 0;

    -khtml-user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;

    h2 {
      margin-bottom: 28px;
      font-size: 32px;
      line-height: 40px;
    }
    .discover-more {
      margin-top: 40px;
    }

    @media (max-width: 1919px) {
      padding: 72px 0;
    }

    @media (max-width: 1247px) {
      padding: 32px 0 56px;

      h2 {
        font-size: 24px;
        line-height: 32px;
        margin-bottom: 28px !important;
      }

      .discover-more {
        margin-top: 32px;
      }
    }

    @media (max-width: 1023px) {
      h2 {
        margin-bottom: 20px;
      }

      .discover-more {
        margin-top: 40px;
      }
    }

    @media (max-width: 743px) {
      padding: 48px 0;

      h2 {
        font-size: 20px;
        line-height: 28px;
        margin-bottom: 30px !important;
      }

      .discover-more {
        margin-top: 32px;
      }
    }

    @media (max-width: 479px) {
      padding: 40px 0;
    }
  }

  .home-offers {
    padding: 80px 0;

    h2 {
      margin-bottom: 28px;
      font-size: 32px;
      line-height: 40px;
    }

    .discover-more {
      margin-top: 40px;
    }

    @media (max-width: 1919px) {
      padding: 72px 0;
    }

    @media (max-width: 1247px) {
      padding: 56px 0;

      h2 {
        font-size: 24px;
        line-height: 32px;
        margin-bottom: 28px !important;
      }

      .discover-more {
        margin-top: 32px;
      }
    }

    @media (max-width: 743px) {
      padding: 48px 0;

      h2 {
        font-size: 20px;
        line-height: 28px;
        margin-bottom: 30px !important;
      }

      .discover-more {
        margin-top: 24px;
      }
    }

    @media (max-width: 479px) {
      padding: 56px 0;
    }
  }

  .home-vlogs {
    padding: 80px 0 0;

    h2 {
      margin-bottom: 32px;
    }

    .discover-more {
      margin-top: 24px;
    }

    @media (max-width: 1919px) {
      padding: 72px 0 0;
    }

    @media (max-width: 1280px) {
      padding: 72px 0 32px;
    }

    @media (max-width: 1247px) {
      padding: 56px 0 16px;

      .discover-more {
        margin-top: 20px;
      }
    }

    @media (max-width: 1023px) {
      padding: 56px 0 24px;
    }

    @media (max-width: 743px) {
      padding: 48px 0 24px;

      h2 {
        margin-bottom: 20px;
      }

      .discover-more {
        margin-top: 24px;
      }
    }

    @media (max-width: 479px) {
      padding: 40px 0 16px;

      .discover-more {
        margin-top: 20px;
      }
    }
  }
`;

export const SliderContainer = styled.div`
  width: 100%;
  position: relative;

  .slick-list {
    overflow: visible;
  }

  .slick-slider {
    button {
      top: -64px;
      right: 16px;
      left: auto;
      width: 48px;
      height: 48px;
      padding: 8px;
      transform: rotate(180deg);
      background-size: 24px;
      background-position: center;
      background-repeat: no-repeat;
      z-index: 2;

      &:before {
        display: none;
      }

      &.slick-prev {
        right: 72px;
        transform: rotate(0deg);
      }

      &.slick-next:disabled,
      &.slick-next[disabled],
      &.slick-prev:disabled,
      &.slick-prev[disabled] {
        background: #ffffff00;

        svg path {
          fill: #091e424f;
        }
      }

      @media (hover: hover) {
        &:hover {
          background-color: #f9f9f8;
        }
      }
    }
  }

  &.without-slider {
    .slick-track {
      margin-left: inherit;
    }

    .slick-slider {
      button {
        display: none !important;
      }
    }
  }
`;
